import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import JoditEditor from "jodit-react";

const CrearGestionModal = ({ id }) => {
  const [formData, setFormData] = useState({
    idSolicitud: id,
    descripcion: "", // Maneja HTML generado por el editor
    fechaCreacion: new Date().toISOString().split("T")[0],
    idUsuario: "1",
  });
  const [isOpen, setIsOpen] = useState(false);
  const [estados, setEstados] = useState([]);
  const [estadoSeleccionado, setEstadoSeleccionado] = useState("");

  useEffect(() => {
    axios
      .get("https://contratosback.azurewebsites.net/api/v1/ObtieneEstado")
      .then((response) => {
        setEstados(response.data);
      })
      .catch((error) => {
        console.error("Error obteniendo los estados", error);
      });
  }, []);

  const toggle = () => setIsOpen(!isOpen);

  const handleEditorChange = (value) => {
    setFormData({ ...formData, descripcion: value });
  };

  const handleEstadoChange = (e) => {
    setEstadoSeleccionado(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post(
        "https://contratosback.azurewebsites.net/api/v1/CreaGestion",
        JSON.stringify(formData),
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      )
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Éxito",
          text: "Gestión creada correctamente",
        });
        toggle();
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Hubo un problema al crear la gestión",
        });
      });
  };

  const handleActualizarSolicitud = () => {
    if (!estadoSeleccionado) {
      Swal.fire("Error", "Seleccione un estado", "error");
      return;
    }
    axios
      .put(
        `https://contratosback.azurewebsites.net/api/v1/ActualizaSolicitudJuridica/${id}`,
        { estado: estadoSeleccionado },
        {
          headers: { "Content-Type": "application/json" },
        },
      )
      .then(() => {
        Swal.fire("Éxito", "Solicitud actualizada correctamente", "success");
      })
      .catch(() => {
        Swal.fire("Error", "No se pudo actualizar la solicitud", "error");
      });
  };

  return (
    <div className="text-center mt-4">
      <Button color="info" onClick={toggle}>
        Crear Nueva Gestión
      </Button>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        style={{ maxWidth: "90%", width: "90%", height: "80%" }}
      >
        <ModalHeader toggle={toggle}>Crear Gestión</ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <Label for="descripcion">Descripción</Label>
              <JoditEditor
                value={formData.descripcion}
                onChange={handleEditorChange}
              />
            </FormGroup>
            <FormGroup>
              <Label for="estado">Estado de la Solicitud</Label>
              <Input
                type="select"
                id="estado"
                value={estadoSeleccionado}
                onChange={handleEstadoChange}
              >
                <option value="">Seleccione un estado</option>
                {estados.map((estado) => (
                  <option key={estado.id} value={estado.id}>
                    {estado.nombre}
                  </option>
                ))}
              </Input>
            </FormGroup>
            <Button color="primary" type="submit">
              Crear
            </Button>
            <Button
              color="warning"
              onClick={handleActualizarSolicitud}
              className="ml-2"
            >
              Actualizar Estado
            </Button>
          </Form>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default CrearGestionModal;
